import { StreamingPlayerError, StreamingPlayerWidgetLayout } from '@heardis/stream-contracts';
import { useEffect, useState } from 'react';
import { useAuthContext } from '../../contexts/AuthContext';
import { useConfigContext } from '../../contexts/ConfigContext';
import { SettingsContextAnalyticsStatus, useSettingsContext } from '../../contexts/SettingsContext';
import useConfig from '../../hooks/useConfig';
import { getWidgetLayout } from '../../utils/view';
import Head from '../Head/Head';
import CookieContainer from '../InfoContainer/CookieContainer';
import LoginContainer from '../InfoContainer/LoginContainer';
import LoadingScreen from '../PageLayout/LoadingScreen/LoadingScreen';
import WidgetLayout from '../WidgetLayout/WidgetLayout';
import StreamingPlayer from './StreamingPlayer';

interface WidgetViewProps {
  /**
   * @TOASK It expects the defaultProps to be set like "PageView.defaultProps = {}"
   * Is it something we want to leave enabled and do it like this or can we just turn it off?
   * */
  forceEnabled?: boolean;
}

function WidgetView({ forceEnabled = false }: WidgetViewProps): JSX.Element {
  const { ui, type, private: authEnabled } = useConfigContext();
  const { user } = useAuthContext();
  const { configIsLoading, errorMessage } = useConfig();
  const { analytics } = useSettingsContext();
  const [widgetLayout, setWidgetLayout] = useState(StreamingPlayerWidgetLayout.REGULAR);
  const showLogin = authEnabled && !user;
  const analyticsPreferencesNotSet = analytics === SettingsContextAnalyticsStatus.NOT_SET;

  useEffect(() => {
    const currentWidgetLayout = getWidgetLayout();
    setWidgetLayout(currentWidgetLayout);
  }, []);

  if (configIsLoading) return <LoadingScreen message="Loading config..." />;
  if (errorMessage) return <LoadingScreen message={`Error loading config: ${StreamingPlayerError.FAILED_TO_LOAD_CONFIG}`} />;
  if (!ui.widget.enabled && !forceEnabled) return <LoadingScreen message={`View is not supported: ${StreamingPlayerError.VIEW_NOT_ENABLED}`} />;

  return showLogin ? (
    <>
      {analyticsPreferencesNotSet && <CookieContainer backgroundColor={ui.widget.player.background.color} typography={ui.widget.player.typography} />}
      {!analyticsPreferencesNotSet && <LoginContainer backgroundColor={ui.widget.player.background.color} typography={ui.widget.player.typography} />}
    </>
  ) : (
    <StreamingPlayer type={type} autoplay={ui.widget.features.autoplay}>
      <Head />
      <WidgetLayout widget={ui.widget} widgetLayout={widgetLayout} />
    </StreamingPlayer>
  );
}

export default WidgetView;
